import { getAccess, useAccess } from './accessStore';

export const ACCESS_FEATURE_FLAGS = ['ai-assistant', 'breakdown-history', 'whatsapp', 'voip'];

export const ACCESS_PLATFORMS = ['portal', 'pwa'];

export const ACCESS_PERMISSIONS = [
  'vehicles:create',
  'events:eventDetails:customDetails',
  'documents:create',
  'inspections:new',
];

export const VEHICLES_CREATE_PERMISSION = 'vehicles:create';

export const EVENT_CUSTOM_DETAILS_PERMISSION = 'events:eventDetails:customDetails';

export const CREATE_DOCUMENT_PERMISSION = 'documents:create';

export const NEW_INSPECTIONS_PERMISSION = 'inspections:new';

export const hasAccessToken = (tokens, token) => {
  if (!tokens || tokens.length === 0) return false;
  const normalizedToken = token.trim().toLowerCase();
  return tokens.some((value) => value === '*' || value.trim().toLowerCase() === normalizedToken);
};

export const usePermissionAccess = (permission) =>
  hasAccessToken(useAccess().permissions, permission);

export const useFeatureAccess = (featureFlag) =>
  hasAccessToken(useAccess().featureFlags, featureFlag);

export const usePlatformAccess = (platform) => hasAccessToken(useAccess().platforms, platform);

export const hasPermission = (permission) => hasAccessToken(getAccess().permissions, permission);

export const hasFeature = (featureFlag) => hasAccessToken(getAccess().featureFlags, featureFlag);

export const hasPlatform = (platform) => hasAccessToken(getAccess().platforms, platform);
